'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('piperList', {
      url: '/piper/:type/list',
      template: '<piper-list></piper-list>'
    });
}



// WEBPACK FOOTER //
// ./client/app/piper/list/show/list.routes.js